import React from 'react'
import Vouchers from 'src/content/Voucher/Vouchers'

const VoucherPage = (props: any) => {
  return <Vouchers props={props} />
}
export default VoucherPage
